import { Form } from 'formik';
import styled from 'styled-components';

import { device } from '../../globalStyle';

export const SerialInputs = styled.div.attrs((props) => ({
  margin: props.margin ? '25px' : 0,
  width: props.width ? props.width : '40%',
}))`
  display: flex;
  position: relative;
  body[dir='ltr'] & {
    margin-left: 0;
  }
  body[dir='rtl'] & {
    margin-right: 0;
  }
  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    @media only screen and (${device.sm}) {
      justify-content: space-between;
      & > div.error {
        position: absolute;
        bottom: -2rem;
      }
    }
  }
  @media only screen and (${device.sm}) {
    gap: 15px;
    flex-direction: row;
  }
  flex: 1 1 100%;
  flex-direction: column;
`;

export const ContestForm = styled(Form)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: var(--space-lg);
`;

export const ContestDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > div {
    flex: 1 1 100%;
    margin-bottom: 30px;
  }
`;

export const Overlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  height: 100%;
  opacity: 0.7;
  position: fixed;
  background-color: #000;
`;
